import { Component, OnInit } from '@angular/core';
import { empty } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../services/api.service';
import { AuthGuard } from '../../guards/auth.guard';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements OnInit {
  username: string;
  companyName: string;
  userScore: string;
  constructor(private toastr: ToastrService, private apiService: ApiService,
    private router: Router, private authService: AuthGuard, private route: ActivatedRoute) { }

  ngOnInit() { 
    this.getProfile();
  }

  getProfile()
  {
      this.apiService.getUserProfile()
      .subscribe((res: any) => {
          if(res.status === 'Success') {       
            this.username  = localStorage.getItem('user_name');
            this.companyName  = res.data.companyName;
            this.userScore = res.data.rewards;
            localStorage.setItem('user_company',res.data.companyName);
            localStorage.setItem('user_score',res.data.rewards);
            localStorage.setItem('user_left_attempts',res.data.leftAttempts);
            localStorage.setItem('daily_checks_count',res.data.dailyChecks);
            localStorage.setItem('team_count',res.data.myTeamCount);
            localStorage.setItem('reviews_count',res.data.myReviewsCount);
            localStorage.setItem('bounties_count',res.data.bonusBounties);
            localStorage.setItem('deals_count',res.data.deals);
            localStorage.setItem('impacts_count',res.data.impacts);
            localStorage.setItem('team_rank',res.data.teamRank);
          }
      });
  }

  getImage()
  {
    let profilePic = localStorage.getItem('user_image');
    if(profilePic == "null")
    {
      return "../../../../assets/images/profile.png";
    }
    else {
      return environment.profileBaseUrl + profilePic;
    }
  }
 
  logout() {
    const data = {
      id: localStorage.getItem('user_id'),
      refreshToken : localStorage.getItem('refresh_token'),
      };
     
      this.apiService.logoutUser(data)
        .subscribe((res: any) => {
            if(res.status === 'Success') {                   
              localStorage.clear();
              this.router.navigateByUrl ('/');
            } else {        
                this.toastr.error('Error in Response');
            }
        }, (err) => {
            if (err.status === 400) {
                this.toastr.error(err.error.message);
            } else if (err.status === 500) {
                this.toastr.error('Internal Server Error');
            } else {
                this.toastr.error('Server Not Responding');
            }
        });
}


  login()
  {
    this.router.navigateByUrl('/session/login');
  }

}
